<template>
  <div>
    <v-snackbar
      absolute
      right
      top
      class="mr-n2"
      v-model="ErrorToast"
      color="error"
      outlined timeout="1000"
    >
      <div class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <v-icon color="error" size="22">mdi-alert-circle-outline</v-icon>
          <span class="mt-n1 ml-5 text_style">Deleted  Successfully</span>
        </div>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "ErrorToastComponent",
  props: ["ErrorToast"],
  methods:{
    tsnackbarClose() { 
     this.$emit("close")
      
    },
  },
};
</script>